import {HttpError} from '@hconnect/common/types'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useSnackbar} from 'notistack'

import {useAxios} from '../hooks'
import {AssetConfigurationDto} from '../types'

import {GetAssetConfigQueryKey} from './useGetAssetConfig'
import {GetKilnInfoQueryKey} from './useGetKilnInfo'
import {usePlantUpmId} from './useGetPlantUpmId'

export const useUpdateAssetConfig = () => {
  const {enqueueSnackbar, closeSnackbar} = useSnackbar()
  const axiosInstance = useAxios()
  const plantUpmId = usePlantUpmId()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (kilnConfig: AssetConfigurationDto) => {
      const path = `asset-config/kms-data/plant/${plantUpmId}/upm-type/Department?typeUpmId=${kilnConfig.metadata.typeUpmId}`
      return (await axiosInstance.put(path, {...kilnConfig.payload})).data
    },
    onSuccess: async (kilnConfig: AssetConfigurationDto) => {
      queryClient.setQueryData(
        [GetAssetConfigQueryKey, plantUpmId, kilnConfig.metadata.typeUpmId],
        kilnConfig
      )
      enqueueSnackbar('Kiln config updated successfully', {
        variant: 'success',
        autoHideDuration: 2500,
        preventDuplicate: true,
        onClick: () => closeSnackbar()
      })
      await queryClient.invalidateQueries({queryKey: [GetKilnInfoQueryKey, plantUpmId]})
    },
    onError: (error: AxiosError<HttpError>) => {
      enqueueSnackbar(`Kiln config could not be updated: ${error.message}`, {
        variant: 'error',
        preventDuplicate: true,
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        onClick: () => closeSnackbar()
      })
    }
  })
}
